import UltMeta, { Meta } from "./UltMeta/index";

class ScanCodeUpload extends UltMeta {
    OUTBOUND = new Meta(1, "出库");
    ENTRY = new Meta(2, "入库");
    INVENTORY = new Meta(3, "盘点");
    SPOTCHECK = new Meta(4, "抽检");
}

export const SCAN_CODE_UPLOAD_TYPE = new ScanCodeUpload();
